import { useEffect, useRef } from 'react';

const useUfoLoadingStatus = (loadingStatus?: string): string => {
	const previousStatusRef = useRef<string | null>(null);

	// Track if we've ever had a loading status
	useEffect(() => {
		if (loadingStatus) {
			previousStatusRef.current = loadingStatus;
		}
	}, [loadingStatus]);

	// Simple logic for determining the status
	if (loadingStatus) {
		// If we have a current status, use it directly
		return loadingStatus;
	} else if (previousStatusRef.current) {
		// If we had a status before but not anymore, we're rendering
		return 'RENDERING';
	} else {
		// If we never had a status, we're pending
		return 'PENDING';
	}
};

export default useUfoLoadingStatus;
